import React, { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import marketingCategoryTabStyles from './marketingCategoriesTabStyles';

interface IMarketingCategoriesTabs {
  marketingCategories: string[];
  currentTab: string;
  onFilterTabNavigate: (value: string) => void;
  isTrimLevel?: boolean;
}

const MarketingCategoriesTabs: FC<IMarketingCategoriesTabs> = ({
  onFilterTabNavigate,
  marketingCategories,
  currentTab,
  isTrimLevel,
}) => {
  const styles = marketingCategoryTabStyles({ hasBottomBorder: !isTrimLevel });

  return (
    <Box className={styles.container}>
      <Box className={styles.marketingCategoryContainer} data-test={`tab:marketingCategoryTabs`}>
        <Tabs
          value={currentTab}
          onChange={(_e, value: string) => onFilterTabNavigate(value)}
          centered={true}
          classes={{ indicator: styles.indicator }}
        >
          {marketingCategories.map((marketingCategory: string) => (
            <Tab
              value={marketingCategory}
              key={marketingCategory}
              label={
                <Typography variant="caption" className={styles.label}>
                  {marketingCategory}
                </Typography>
              }
              data-test={`tab:switch_marketingCategory:${marketingCategory}`}
              classes={{
                selected: isTrimLevel ? styles.selectedTrimTab : styles.selectedTab,
                root: isTrimLevel ? styles.trimTab : styles.tab,
                wrapper: styles.wrapper,
              }}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
};

export default MarketingCategoriesTabs;
